import { z } from 'zod';
import { Api } from '@automapa/svelte-automapa-template';
import { SettingsApi } from '../components/Settings/SettingsApi';
import type { localStorageFilterType } from '../components/telematics/components/FilterByParameters/FilterManager';
import { FilterManagerIO } from '../components/telematics/components/FilterByParameters/FilterManagerIO';

export class CustomFilterManagerIO extends FilterManagerIO {
    constructor(api: Api, filterManagerStorageKey: string) {
        super(
            async () => {
                let data = await SettingsApi.getClientSettings<localStorageFilterType>(
                    api,
                    filterManagerStorageKey || '',
                    z.any()
                );
                console.log('TelematicsFilter, load', data);
                return data;
            },
            async data => {
                console.log('TelematicsFilter, save', data);
                await SettingsApi.setClientSettings<localStorageFilterType>(
                    api,
                    filterManagerStorageKey || '',
                    data,
                    z.any()
                );
            }
        );
    }
}
